var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#FF7F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#FF7F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9842 84.9714C64.8012 84.2565 81.8147 68.5727 84.5979 48.3464L74.8521 38.6006L9.95729 46.2562L36.2993 72.5983L33.4638 74.4508L43.9842 84.9714Z",
    fill: "#E03A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1467 47.2222H11.853C10.5227 47.2222 9.44414 46.1438 9.44414 44.8133V40.1865C9.44414 38.8562 10.5226 37.7776 11.853 37.7776H73.1467C74.4769 37.7776 75.5555 38.856 75.5555 40.1865V44.8133C75.5555 46.1439 74.4771 47.2222 73.1467 47.2222Z",
    fill: "#262625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0556 75.9537L34.939 75.3255C33.7633 75.1813 32.9274 74.1111 33.0716 72.9352L36.5772 44.3835C36.7215 43.2078 37.7916 42.3719 38.9672 42.5162L44.0838 43.1444C45.2595 43.2887 46.0954 44.3588 45.9511 45.5347L42.4455 74.0864C42.3014 75.2619 41.2313 76.098 40.0556 75.9537Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9444 75.9537L50.061 75.3255C51.2367 75.1813 52.0726 74.1111 51.9284 72.9352L48.4228 44.3835C48.2785 43.2078 47.2084 42.3719 46.0325 42.5162L40.9159 43.1444C39.7402 43.2887 38.9043 44.3588 39.0485 45.5347L42.5541 74.0864C42.6986 75.2619 43.7687 76.098 44.9444 75.9537Z",
    fill: "#565654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3533 50.1556H37.6464C36.4149 50.1556 35.4163 49.1574 35.4163 47.9255V38.2186C35.4163 36.9871 36.4145 35.9885 37.6464 35.9885H47.3533C48.5848 35.9885 49.5834 36.9868 49.5834 38.2186V47.9255C49.5834 49.1574 48.5851 50.1556 47.3533 50.1556Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3533 35.989H42.2613V50.1556H47.3533C48.5848 50.1556 49.5834 49.1574 49.5834 47.9255V38.2186C49.5834 36.9873 48.5851 35.989 47.3533 35.989Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon2);
export default __webpack_public_path__ + "static/media/priority_icon_2.e53cc0c9eae5c79a11fe3f2c8af409fd.svg";
export { ForwardRef as ReactComponent };